var _rect, _rect2, _rect3, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#5E3EEB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "white",
    fillOpacity: 0.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#3F7CDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 22C36.3456 22 37.0184 22 37.8263 22.6199C38.0343 22.7795 38.2205 22.9657 38.3801 23.1737C39 23.9816 39 25.1544 39 27.5V32C39 34.8284 39 36.2426 38.1213 37.1213C37.2426 38 35.8284 38 33 38H25C22.1716 38 20.7574 38 19.8787 37.1213C19 36.2426 19 34.8284 19 32V27.5C19 25.1544 19 23.9816 19.6199 23.1737C19.7795 22.9657 19.9657 22.7795 20.1737 22.6199C20.9816 22 21.6544 22 24 22",
    stroke: "#3F7CDB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 23L33.1142 20.7854C32.732 19.83 32.3994 18.7461 31.4166 18.2596C30.8924 18 30.2616 18 29 18C27.7384 18 27.1076 18 26.5834 18.2596C25.6006 18.7461 25.268 19.83 24.8858 20.7854L24 23",
    stroke: "#3F7CDB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 30C32.5 31.933 30.933 33.5 29 33.5C27.067 33.5 25.5 31.933 25.5 30C25.5 28.067 27.067 26.5 29 26.5C30.933 26.5 32.5 28.067 32.5 30Z",
    stroke: "#3F7CDB",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 22H29.009",
    stroke: "#3F7CDB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.ba187a211c4d4df93f4f2c85332e7bee.svg";
export { ForwardRef as ReactComponent };